/**
 * @module Sagas/App
 * @desc App
 */

import { delay } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { request } from 'modules/api';
import { ActionTypes } from 'constants/index';

const CONFIG = require('../../../config.json');

export function* getRepos({ payload }) {
  try {
    const response = yield call(request, `https://api.github.com/search/repositories?q=${payload.query}&sort=stars`);
    yield put({
      type: ActionTypes.GITHUB_GET_REPOS_SUCCESS,
      payload: { data: response.items },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GITHUB_GET_REPOS_FAILURE,
      payload: err,
    });
  }
}

/**
 * drawerStatusChange
 */
export function* drawerStatusChange() {
  yield put({
    type: ActionTypes.DRAWER_CHANGED,
  });
}

export function* closeIntro() {
  yield put({
    type: ActionTypes.CLOSE_INTRO,
  });
}

export function* showIntro() {
  yield put({
    type: ActionTypes.SHOW_INTRO,
  });
}

export function* getEdges() {
  try {
    //const response = yield call(request, './edges.json');
    let response = require('../../../edges.json');
    let edges = [];
    let index = 1;
    for (let edge of response) {
      if (!edge.id) {
        edge.id = index;
      }
      index++;
      edges.push(edge);
    }
    yield put({
      type: ActionTypes.GET_EDGES_SUCCESS,
      payload: { data: edges },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_EDGES_FAILURE,
      payload: err,
    });
  }
}

export function* getNodes({ payload }) {
  try {
    const tag = payload.tag;
    //const response = yield call(request, './nodes.json');
    const response = require('../../../nodes.json');
    const nodes = [];
    const allnodes = [];
    for (const node of response) {
      if (!node.image) {
        node.image = CONFIG.genericicons[node.type];
      }
      if (node.image) {
        node.shape = 'circularImage';
      }
      node.title = node.label;
      if (node.type === 'terror-organization') {
        node.color = { border: 'red', highlight: { background: 'red', border: 'red' }, hover: { background: 'red', border: 'red' } };
      }

      allnodes.push(node);

      const tagstr = node.tags;
      if (tag === '' || !tag) {
        nodes.push(node);
      } else if (tagstr) {
        const tags = tagstr.split(',');
        const search_tags = tag.split('+');

        let index = 0;
        for (const search_tag of search_tags) {
          if (tags.indexOf(search_tag) !== -1) {
            index++;
          }
        }

        if (index === search_tags.length) {
          nodes.push(node);
        }
      }
    }
    yield put({
      type: ActionTypes.GET_NODES_SUCCESS,
      payload: { data: nodes },
    });
    yield put({
      type: ActionTypes.GET_ALL_NODES_SUCCESS,
      payload: { data: allnodes },
    });
    yield put({
      type: ActionTypes.SET_TAG_SUCCESS,
      payload: { data: tag },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_NODES_FAILURE,
      payload: err,
    });
  }
}

export function* setDetail({ payload }) {
  try {
    yield put({
      type: ActionTypes.SET_DETAIL_SUCCESS,
      payload: { info: payload },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.SET_DETAIL_FAILURE,
      payload: err,
    });
  }
}

export function* getHtml({ payload }) {
  try {
    const response = yield call(request, '../html/test.html');
    yield put({
      type: ActionTypes.GET_HTML_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_HTML_FAILURE,
      payload: err,
    });
  }
}

export function* infoDrawerStatusChange() {
  yield put({
    type: ActionTypes.INFO_DRAWER_CHANGED,
  });
}

export function* getNodesByCountry({ payload }) {
  try {
    const country = payload.country;
    const response = require('../../../nodes.json');
    const nodes = [];
    for (const node of response) {

      if (!node.image) {
        node.image = CONFIG.genericicons[node.type];
      }
      if (node.image) {
        node.shape = 'circularImage';
      }
      node.title = node.label;
      if (node.type === 'terror-organization') {
        node.color = { border: 'red', highlight: { background: 'red', border: 'red' }, hover: { background: 'red', border: 'red' } };
      }

      const countrystr = node.country;
      if (countrystr) {
        if (countrystr === country) {
          nodes.push(node);
        }
      }
    }
    yield put({
      type: ActionTypes.GET_NODES_SUCCESS,
      payload: { data: nodes },
    });
  } catch (err) {
    /* istanbul ignore next */
    yield put({
      type: ActionTypes.GET_NODES_FAILURE,
      payload: err,
    });
  }
}

/**
 * App Sagas
 */
export default function* root() {
  yield all([
    takeLatest(ActionTypes.DRAWER_CHANGE, drawerStatusChange),
    takeLatest(ActionTypes.GET_EDGES, getEdges),
    takeLatest(ActionTypes.GET_NODES, getNodes),
    takeLatest(ActionTypes.SET_DETAIL, setDetail),
    takeLatest(ActionTypes.GET_HTML, getHtml),
    takeLatest(ActionTypes.INFO_DRAWER_CHANGE, infoDrawerStatusChange),
    takeLatest(ActionTypes.GET_NODES_BY_COUNTRY, getNodesByCountry),
  ]);
}



// WEBPACK FOOTER //
// ./scripts/sagas/app.js